import { Controller } from "@hotwired/stimulus"

// Shows or hides the sentence under each layoff row. The sentences are always
// in the page; this only flips a class the stylesheet reads, so what a crawler
// or an agent reads never depends on it. The switch is a checkbox, so its own
// checked state is what a screen reader hears.
//
// The choice is remembered in this browser, because a reader who wants the
// detail wants it on the next company page too. Storage can be refused, in a
// private window or with site data blocked, and then the switch still works
// for the page in front of them.
const KEY = "layoff-details"

export default class extends Controller {
  connect() {
    let remembered = null
    try {
      remembered = window.localStorage.getItem(KEY)
    } catch (error) {
      // No storage: start from the default.
    }
    this.show(remembered === "shown")
  }

  toggle(event) {
    const shown = event.target.checked
    this.show(shown)
    try {
      window.localStorage.setItem(KEY, shown ? "shown" : "hidden")
    } catch (error) {
      // Not remembered, still applied.
    }
  }

  show(shown) {
    this.element.classList.toggle("layoff-events--detailed", shown)
    const input = this.element.querySelector(".layoff-events__bar input[type=checkbox]")
    if (input) input.checked = shown
  }
}
